module.exports = __webpack_public_path__ + "static/media/service1.c4515316.jpg";